import React, { ForwardedRef } from 'react';

import { useSelector } from 'react-redux';

import { StatusEnum } from '@common/constants';

import { WellnessTypesEnum } from '../../constants';
import { waterDataSelector, getItemsSelector } from '../../store';
import { Dashboard, useDashboard } from '../Dashboard';
import { MEASUREMENT_TYPES } from './constants';
import { locale } from './locale';

type WaterDashboardComponentProps = {
  setRef: ForwardedRef<HTMLDivElement>;
};

export function WaterDashboardComponent({ setRef }: WaterDashboardComponentProps) {
  const { requestLogStatus, summaryData, summaryMonth, removeStatus } = useSelector(waterDataSelector);
  const items = useSelector(getItemsSelector(WellnessTypesEnum.Water));

  const { chartData, handleHistoryItemClick, handleRecordButtonClick, handleDeleteItemClick } = useDashboard({
    summaryMonth,
    summaryData,
    type: WellnessTypesEnum.Water,
  });

  return (
    <div ref={setRef}>
      <Dashboard
        type={WellnessTypesEnum.Water}
        heading={locale.dashboard_title}
        chartTitle={locale.title}
        data={chartData}
        measurements={MEASUREMENT_TYPES}
        selectedMeasurement={MEASUREMENT_TYPES[0]}
        historyItems={items}
        historyTitle={locale.history_title}
        loading={
          [StatusEnum.Pending, StatusEnum.Uninitialized].includes(requestLogStatus) ||
          removeStatus === StatusEnum.Pending
        }
        recordButtonText={locale.record_activity}
        onRecordButtonClick={handleRecordButtonClick}
        onEditItemClick={handleHistoryItemClick}
        onDeleteItemClick={handleDeleteItemClick}
      />
    </div>
  );
}

export const WaterDashboard = React.forwardRef<HTMLDivElement>((props, ref) => (
  <WaterDashboardComponent setRef={ref} {...props} />
));

WaterDashboard.displayName = 'WaterDashboard';
